import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import {
  Header,
  CalendarDropdown,
  DropdownWrapper,
  BottomDiv,
  InputDiv,
  Inputs,
  InputLabel,
  Input,
  ButtonsDiv
} from '../styles';
import IconButton from '../../../component/button/iconButton';
import CalendarcomponentV2 from '../../../component/calendarPopUp/calendarComponentV2';
import TimePickerModal from '../../../component/timePicker';
import Button from '../../../component/button';
import InputComponent from '../../../component/input';
import { ICON_BUTTON_SIZE, ICON_BUTTON_TYPE, BUTTON_TYPE } from '../../../global/constants';
import { SnoozeCalendarProps } from '../../../interfaces/NotificationInterface';

const SnoozeCalendar: React.FC<SnoozeCalendarProps> = ({
  dropdownRef,
  buttonHeight,
  position,
  alignment,
  dropdownTopOffset,
  selectedDate,
  selectedTime,
  onBack,
  onCancel,
  onSnooze,
  onDateChange,
  onTimeChange
}) => {
  return (
    <CalendarDropdown
      role='button'
      ref={dropdownRef}
      onClick={(e) => e.stopPropagation()}
      buttonHeight={buttonHeight}
      direction={position}
      alignment={alignment}
      dropdownTopOffset={dropdownTopOffset}
      className='reference-item'>
      <Header>
        <IconButton
          iconName='new-large-back-arrow-icon'
          size={ICON_BUTTON_SIZE.EXTRA_SMALL}
          variant={ICON_BUTTON_TYPE.TERTIARY}
          onClick={(e: React.SyntheticEvent) => {
            e.stopPropagation();
            onBack();
          }}
        />
        <p>Snooze</p>
      </Header>
      <DropdownWrapper>
        <CalendarcomponentV2 isInbox={true} setCalendarDate={(date: Date) => onDateChange(date)} />
      </DropdownWrapper>
      <BottomDiv>
        <InputDiv>
          <Inputs>
            <InputComponent type='text' placeHolder='DD/MM/YY' value={selectedDate} isDisabled label='Date' />
          </Inputs>
          <Inputs>
            <InputLabel>Time</InputLabel>
            <Input role='button' onClick={(e) => e.stopPropagation()}>
              <TimePickerModal
                value={dayjs(selectedTime, 'HH:mm')}
                onSelect={(value: Dayjs) => onTimeChange(value.format('HH:mm'))}
              />
            </Input>
          </Inputs>
        </InputDiv>
        <ButtonsDiv>
          <Button
            title='Cancel'
            variant={BUTTON_TYPE.SECONDARY}
            className='button'
            onClick={(e: React.SyntheticEvent) => {
              e.stopPropagation();
              onCancel();
            }}
          />
          <Button
            title='Snooze'
            variant={BUTTON_TYPE.PRIMARY}
            className='button'
            onClick={(e: React.SyntheticEvent) => {
              e.stopPropagation();
              onSnooze();
            }}
          />
        </ButtonsDiv>
      </BottomDiv>
    </CalendarDropdown>
  );
};

export default SnoozeCalendar;
